import { Component, ContentChild, ContentChildren, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-app-shell',
  templateUrl: './app-shell.component.html',
  styleUrls: ['./app-shell.component.scss']
})
export class AppShellComponent implements OnInit {
  @ContentChild(RouterOutlet) isContentHasRouter: RouterOutlet | undefined;

  constructor() {

  }

  ngOnInit(): void {
  }

}
